import type { ReactNode } from 'react';

import UtilityDottedTrueToSizeMediumIcon from 'tailwind/components/Icons/UtilityDottedTrueToSizeMediumIcon';
import TrueToSizeIcon from 'components/common/IconsV2/TrueToSizeIcon';

export interface RecommendedSizingLayoutProps {
  children?: ReactNode;
  isIncludeIcon?: boolean;
}

const RecommendedSizingLayout = ({ children, isIncludeIcon = true }: RecommendedSizingLayoutProps) => {
  if (!isIncludeIcon) {
    return children;
  }

  return (
    <div className="flex h-fit w-fit gap-x-2">
      <UtilityDottedTrueToSizeMediumIcon size={24} className="flex-none lumon:hidden" />
      <TrueToSizeIcon size={24} className="flex-none not-lumon:hidden" />
      {children}
    </div>
  );
};

export default RecommendedSizingLayout;
